import nocturnaIcon from '../../assets/V2/Vida Nocturna.png'
import lugaresIcon from '../../assets/V2/Lugares para visitar.png'
import gastronomiaIcon from '../../assets/V2/Gastronomia.png'
import eventosIcon from '../../assets/V2/Lentes.png'
import turibusIcon from '../../assets/V2/Bus.png'
import turibus from '../../assets/bg/splash.jpg'
import nocturna from '../../assets/bg/nocturna.png'
import lugares from '../../assets/bg/lugares.png'
import gastronomia from '../../assets/bg/gastronomia.png'
import eventos from '../../assets/bg/evento.jpg'
export default {
  name: 'home-v-2',
  components: {},
  props: [],
  data () {
    return {
      nocturnaIcon,
      gastronomiaIcon,
      lugaresIcon,
      eventosIcon,
      turibusIcon,
      categorias: [
        {
          imagen: eventos,
          logo: eventosIcon,
          texto: 'EVENTOS',
          tipo: 'eventos'
        },
        {
          imagen: gastronomia,
          logo: gastronomiaIcon,
          texto: 'GASTRONOMÍA',
          tipo: 'gastronomia'
        },
        {
          imagen: lugares,
          logo: lugaresIcon,
          texto: 'LUGARES A VISITAR',
          tipo: 'lugares'
        },
        {
          imagen: nocturna,
          logo: nocturnaIcon,
          texto: 'VIDA NOCTURNA',
          tipo: 'nocturna'
        },
        {
          imagen: turibus,
          logo: turibusIcon,
          texto: 'TURIBUS JUÁREZ',
          tipo: 'turibus'
        }
      ]
    }
  },
  computed: {},
  mounted () {},
  methods: {
    verCategoria (tipo) {
      // alert(tipo)
      this.$router.push({ name: 'directorio', params: { tipo: tipo, ciudad: this.$route.params.ciudad } })
    }
  }
}
